import React, { useEffect, useState } from 'react';
import { getData } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import HomeScreen from './home';


function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change} = useRefresh();
    const [menus, setMenus] = useState([]);

    const [showHome, setShowHome] = useState(false);
    const [showBuffet, setShowBuffet] = useState(false);
    const [showCumple, setShowCumple] = useState(false);

    const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [showHappy, setShowHappy] = useState(false);
    const [showExecutiveMenu, SetshowExecutiveMenu] = useState(false);
    const [showBar, setShowBar] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [dataFood, setDataFood] = useState(false);
    
    
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
    }, [change]);



      useEffect(() => {
              menus.map((item) => {
                  if (item.id === 435) {
                  setDataFood(item);
                  }
             
             
              });
      }, [menus]);
    
    
    useEffect(() => {
        const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            console.log("La página ha perdido el foco (está oculta).");
            setShowHome(false)

        } else if (document.visibilityState === "visible") {
            console.log("La página está en foco (visible).");
        }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Limpieza del evento al desmontar el componente
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);



    window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
        };


    return (
       
        <LayoutContent showFooter={false} showBack={false} showImageTop={true} setShowSpecials={setShowSpecials} goCategories={setshowCategories}>
            <div>
                <div style={{ width: '100%' }}>
                    
                </div>
                <div  onClick={()=> setShowHome(true)}>
                    <img
                            onContextMenu={(e) => e.preventDefault()}
                            src={require('./assets/home.jpeg')}
                            loop autoPlay={true} muted 
                            style={{
                                marginTop: -40,
                                width: '100%',
                                 pointerEvents: 'none',
                                height:850,
                                objectFit: 'contain',
                                borderRadius: 14,
                               
                               
                            }}
                />
               </div>

                <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}>
                    <button
                        onClick={() => setShowHome(true)}
                        style={{
                            backgroundColor: '#b71c1c',
                            color: '#fff',
                            border: 'none',
                            borderRadius: 30,
                            padding: '14px 48px',
                            fontSize: 20,
                            fontWeight: 'bold',
                            cursor: 'pointer',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                            textTransform: 'uppercase'
                        }}
                    >
                        {langEng ? 'View menu' : 'Ver menú'}
                    </button>
                </div>

            </div>

            {showHome && <HomeScreen setShowBar={setShowHome} />}
            </LayoutContent>
           
    );
}

export default Index;